import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Problem } from '../components/sections/Problem';
import { Solution } from '../components/sections/Solution';
import { Audience } from '../components/sections/Audience';
import { HowItWorks } from '../components/sections/HowItWorks';
import { FAQ } from '../components/sections/FAQ';
import { Pricing } from '../components/sections/Pricing';
import { Footer } from '../components/sections/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full font-sans text-brand-dark selection:bg-brand-lavender selection:text-white" data-id="element-202">
      <Hero data-id="element-203" />
      <Problem data-id="element-204" />
      <Solution data-id="element-205" />
      <Audience data-id="element-206" />
      <HowItWorks data-id="element-207" />
      <FAQ data-id="element-208" />
      <Pricing data-id="element-209" />
      <Footer data-id="element-210" />
    </main>;
}